import { Phone, Mail, ExternalLink } from "lucide-react";
import { BOOKING_URL } from "@/lib/api";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-white border-t border-slate-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/tj-logo.png"
                alt="T&J Clinical Solutions logo"
                className="h-10 w-10 object-contain"
                width={40}
                height={40}
              />
              <span className="font-heading font-semibold text-slate-900 tracking-tight">
                T&amp;J Clinical Solutions
              </span>
            </div>
            <p className="mt-4 text-sm text-slate-500 leading-relaxed max-w-xs">
              Healthcare Support Services — reliable, patient-centered, and
              professional. Proudly serving New Jersey, surrounding Pennsylvania
              areas including Philadelphia, and New York communities near
              Staten Island.
            </p>
          </div>

          <div className="md:justify-self-center">
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Explore</div>
            <ul className="space-y-2 text-sm">
              {[
                { href: "#about", label: "About" },
                { href: "#services", label: "Services" },
                { href: "#why-us", label: "Why Us" },
                { href: "#areas", label: "Areas We Serve" },
                { href: "#contact", label: "Contact" },
              ].map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-slate-700 hover:text-brand-teal transition-colors"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
              <li className="pt-1">
                <a
                  href={BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-book-service-link"
                  className="inline-flex items-center gap-1.5 text-brand-teal font-semibold hover:text-brand-navy transition-colors"
                >
                  Book a Service <ExternalLink className="h-3.5 w-3.5" />
                </a>
              </li>
            </ul>
          </div>

          <div className="md:justify-self-end">
            <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Reach us</div>
            <a
              href="tel:5169198679"
              data-testid="footer-phone-link"
              className="flex items-center gap-2 text-sm text-slate-800 hover:text-brand-teal transition-colors"
            >
              <Phone className="h-4 w-4" /> 516-919-8679
            </a>
            <a
              href="mailto:tj.clinicalsolutions@gmail.com"
              data-testid="footer-email-link"
              className="mt-2 flex items-center gap-2 text-sm text-slate-800 hover:text-brand-teal transition-colors break-all"
            >
              <Mail className="h-4 w-4" /> tj.clinicalsolutions@gmail.com
            </a>
            <div className="mt-3 text-xs text-amber-700">
              Flexible Scheduling · NJ · PA · NY
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-slate-500">
            © {year} T&amp;J Clinical Solutions. All rights reserved.
          </p>
          <p className="text-[11px] uppercase tracking-[0.22em] text-slate-400">
            Healthcare Support Services
          </p>
        </div>
      </div>
    </footer>
  );
}
